import React from 'react'
import {  Accordion } from 'react-bootstrap'
import { programok } from "../Database";
import Item from "../Item";
import Pageheader from '../partials/Pageheader';

function Programok() {
	return (
		<>
			<Pageheader>Programok</Pageheader>
			<Accordion flush>
				{programok.map((item, index) =>
					<Item img={item.img} face={item.face} title={item.title} id={index} key={index}>{item.text}</Item>
				)}
			</Accordion>
		</>
	)
}

export default Programok